<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.value" class="input-with-select" size="small">
                        <el-select v-model="params.type" slot="prepend" placeholder="请选择">
                            <el-option label="名称" :value="1"></el-option>
                            <el-option label="标识" :value="2"></el-option>
                            <el-option label="组" :value="3"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.status" placeholder="请选择" size="small">
                        <el-option label="仅看显示的" :value="1"></el-option>
                        <el-option label="仅看隐藏的" :value="0"></el-option>
                        <el-option label="不限制状态" value=""></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-btns-box">           
            <el-button
                type="primary"
                icon="el-icon-plus"
                @click="add"
                size="small"
			    v-if="$utils.have('/h5/resource/info')" 
                >新建元素</el-button
            >
        </div>
        <div class="page-list-box">
            <el-table
                :data="tableData"
                border
                style="width: 100%"
                v-loading="fetchLoading"
                size="small"
                stripe
            >
                <el-table-column label="状态">
                    <template slot-scope="scope">
                        <p v-if="scope.row.status === 1">展示</p>
                        <p v-else-if="scope.row.status === 0">隐藏</p>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="名称" min-width="120" show-overflow-tooltip></el-table-column>
                <el-table-column prop="mark" label="标识"></el-table-column>
                <el-table-column prop="groupName" label="组"></el-table-column>
				<el-table-column label="类型">
					<template slot-scope="scope">
					    <p v-if="scope.row.type === 1">图片</p>
					    <p v-else-if="scope.row.type === 2">文字</p>
						<p v-else-if="scope.row.type === 3">富文本</p>
                        <p v-else-if="scope.row.type === 4">SVGA</p>
                        <p v-else-if="scope.row.type === 5">音频</p>
                        <p v-else-if="scope.row.type === 6">视频</p>
					</template>					
				</el-table-column>
				<el-table-column label="内容">
					<template slot-scope="scope" >
					    <el-image class="img" :src="scope.row.content" fit="cover"  v-if="scope.row.type === 1"/>
						<p v-else-if="scope.row.type === 3">富文本</p>
						<p v-else-if="scope.row.type === 2">{{scope.row.content}}</p>
                        <p v-else-if="(scope.row.type === 4)" class="color-info">暂不支持预览，请在“管理”中查看</p>
                        <el-button v-else-if="(scope.row.type === 5)" type="text" @click="$player.play({playUrl:scope.row.content})">试听</el-button>
                        <el-button v-else-if="(scope.row.type === 6)" type="text" @click="playVideo(scope.row.content)">播放</el-button>
					</template>					
				</el-table-column>
                <el-table-column fixed="right" label="操作" >
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            size="small"
                            icon="el-icon-edit"
                            @click="edit(scope.row.id)"
                            >管理</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="tableData.length > 0" class="page-pagination-box">
            <el-pagination
                background
                @size-change="search"
                @current-change="fetch"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
		<resource-edit ref="ResourceEdit" @update="fetch"  :pageShareConfigId="pageShareConfigId"></resource-edit>
        <VideoPlay ref="videoPlay"></VideoPlay>
    </div>	
</template>

<script>
const defaultQuery = {
    pageNo: 1,
    pageSize: 10,   
    type: 1,
    value: '',
    status: ''
};
import ResourceEdit from './components/resource-edit';
import VideoPlay from "@/components/VideoPlay";
export default {
	components:{ResourceEdit, VideoPlay},
	props: {
	    id: {
	        type: [Number, String],
	        default: null,
	    },
	},
    data() {
        return {
            params: {...defaultQuery},
            fetchLoading: false,
            tableData: [],
		    data: null,
            totalCount: 0,
			pageShareConfigId:'',
        };
    },
    mounted(){
        this.fetch();
    },
    methods: {
   //      async fetch() {  
			// this.listLoading = true;
			// this.$request({
			// 	url: "/h5/resource/list",
			// 	method: "POST",
			// 	data: {
			// 		 ...this.params,
			// 		 configId: this.id                   
			// 	 },
			// })
			// .then((res) => {
			// 	const { state, msg, result } = res.data;
			// 	if ( state == 1 && result.totalCount != 0 ) {
			// 		this.data = result;
			// 		this.tableData = result.result || [];					
			// 	}
			// 	if( state == 1 ){
			// 		this.pageShareConfigId = this.id;					
			// 	}
			// })
			// .catch(() => {
			// 	this.$message.error("请求错误");
			// })
			// .finally(() => {
			// 	this.listLoading = false;
			// });
				
   //      },
		async fetch() {
		    this.listLoading = true;
		    const response = await this.$request({
		        url: "/h5/resource/list",
		        method: "POST",
		        data: {
		        	 ...this.params,
		        	 configId: this.id                   
		         },
		    })
		    const {state, msg, result} = response.data;
		    this.listLoading = false;
		    if (state != 1) return this.$message.error(msg);
			this.data = result;
		    this.tableData = result.result;
		    this.totalCount = result.totalCount;
			this.pageShareConfigId = this.id;
		},
		
        //搜索
        search() {
            this.params.pageNo = 1;
            this.fetch();
        },
        //重置搜索
        reset() {
            this.params = {...defaultQuery};
            this.search();
        },
		//新增事件
		add(){
		    this.$refs.ResourceEdit.show();
		},
		//编辑事件
		edit(id) {
		    this.$refs.ResourceEdit.show(id);
		},
        // 播放视频
        playVideo(url){
            this.$refs.videoPlay.show({url:url});
        }
    },
};
</script>
<style lang="scss" scoped>
.img{
   max-width: 120px;
   max-height: 120px;
}
</style>